export interface ErrorMapping {
  message: string;
  suggestion?: string;
  icon: 'warning' | 'error' | 'info';
}

const ERROR_PATTERNS: Record<string, ErrorMapping> = {
  // Erros de usuário duplicado
  'already registered': {
    message: 'Este email já está cadastrado no sistema',
    suggestion: 'Tente fazer login ou use outro email',
    icon: 'warning'
  },
  'email já está registrado': {
    message: 'Este email já está cadastrado no sistema',
    suggestion: 'Tente fazer login ou use outro email',
    icon: 'warning'
  },
  'user already exists': {
    message: 'Este usuário já existe no sistema',
    suggestion: 'Tente fazer login ou use outro email',
    icon: 'warning'
  },
  'duplicate key': {
    message: 'Este registro já existe',
    suggestion: 'Verifique os dados e tente novamente',
    icon: 'warning'
  },
  
  // Erros de senha
  'password should be at least': {
    message: 'Senha muito fraca',
    suggestion: 'Use pelo menos 6 caracteres',
    icon: 'warning'
  },
  'password': {
    message: 'Problema com a senha',
    suggestion: 'Use pelo menos 6 caracteres com letras e números',
    icon: 'warning'
  },
  
  // Erros de autenticação
  'invalid login credentials': {
    message: 'Email ou senha incorretos',
    suggestion: 'Verifique suas credenciais e tente novamente',
    icon: 'error'
  },
  'email not confirmed': {
    message: 'Email não confirmado',
    suggestion: 'Verifique sua caixa de entrada e confirme seu email',
    icon: 'info'
  },
  'invalid email': {
    message: 'Email inválido',
    suggestion: 'Verifique o formato do email',
    icon: 'warning'
  },
  
  // Erros de permissão
  'permission denied': {
    message: 'Você não tem permissão para esta ação',
    suggestion: 'Entre em contato com o administrador',
    icon: 'error'
  },
  'acesso negado': {
    message: 'Acesso negado',
    suggestion: 'Você não tem permissão para esta ação',
    icon: 'error'
  },
  'unauthorized': {
    message: 'Não autorizado',
    suggestion: 'Faça login novamente',
    icon: 'error'
  },
  'jwt expired': {
    message: 'Sessão expirada',
    suggestion: 'Faça login novamente',
    icon: 'info'
  },
  
  // Erros de rede
  'network': {
    message: 'Problema de conexão',
    suggestion: 'Verifique sua internet e tente novamente',
    icon: 'warning'
  },
  'fetch failed': {
    message: 'Não foi possível conectar ao servidor',
    suggestion: 'Tente novamente em alguns segundos',
    icon: 'warning'
  },
  'failed to fetch': {
    message: 'Falha na conexão',
    suggestion: 'Verifique sua internet e tente novamente',
    icon: 'warning'
  },
  'timeout': {
    message: 'Tempo limite excedido',
    suggestion: 'Tente novamente',
    icon: 'warning'
  },
  
  // Erros de duplicação específicos
  'unique_telefone_org': {
    message: 'Este telefone já está cadastrado em outro lead',
    suggestion: 'Verifique se o lead já existe ou use outro número de telefone',
    icon: 'warning'
  },
  '23505': { // PostgreSQL unique violation
    message: 'Este registro já existe',
    suggestion: 'Verifique os dados e tente novamente',
    icon: 'warning'
  },
  
  // Erros de validação
  'required': {
    message: 'Campo obrigatório não preenchido',
    suggestion: 'Preencha todos os campos obrigatórios',
    icon: 'warning'
  },
  'invalid': {
    message: 'Dados inválidos',
    suggestion: 'Verifique os dados informados',
    icon: 'warning'
  },
  
  // Erros de recurso não encontrado
  'not found': {
    message: 'Registro não encontrado',
    suggestion: 'O item pode ter sido removido',
    icon: 'info'
  },
  
  // Erros de conflito
  '409': {
    message: 'Conflito de dados',
    suggestion: 'Este registro já existe no sistema',
    icon: 'warning'
  }
};

export function parseError(error: unknown): ErrorMapping {
  let errorMessage = '';
  
  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else if (error && typeof error === 'object') {
    errorMessage = (error as any).message || (error as any).error || JSON.stringify(error);
  }
  
  const lowerMessage = errorMessage.toLowerCase();
  
  for (const [pattern, mapping] of Object.entries(ERROR_PATTERNS)) {
    if (lowerMessage.includes(pattern.toLowerCase())) {
      return mapping;
    }
  }
  
  return {
    message: 'Ocorreu um erro inesperado',
    suggestion: 'Tente novamente ou entre em contato com o suporte',
    icon: 'error'
  };
}

export function getErrorMessage(error: unknown): string {
  return parseError(error).message;
}
